import React from 'react'

export default function URL({ urlString, fontSize = 'unset' }) {
  return (<div className="input-group">
    <div className="input-group-prepend">
      <span className="input-group-text" style={{ borderRadius: '2em 0 0 2em', backgroundColor: 'white', color: '#DADADA' }}>
        <i className="fas fa-lock"></i>
      </span>
    </div>
    <input type="text" className="form-control px-0" value={urlString} disabled style={{ borderRight: 0, borderLeft: 0, backgroundColor: 'white', fontSize: fontSize }} />
    <div className="input-group-append">
      <span className="input-group-text" style={{ borderRadius: '0 2em 2em 0', backgroundColor: 'white', color: '#DADADA' }}>
        <i className="fas fa-search"></i>
      </span>
    </div>
  </div>
  )
}
